import { render, staticRenderFns } from "./AgeAnalysis.vue?vue&type=template&id=457ffcd1&scoped=true"
import script from "./AgeAnalysis.vue?vue&type=script&lang=js"
export * from "./AgeAnalysis.vue?vue&type=script&lang=js"
import style0 from "./AgeAnalysis.vue?vue&type=style&index=0&id=457ffcd1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457ffcd1",
  null
  
)

export default component.exports